import { render, staticRenderFns } from "./AppSocialMediaInfoSection.vue?vue&type=template&id=4a7b69be&scoped=true"
import script from "./AppSocialMediaInfoSection.vue?vue&type=script&lang=js"
export * from "./AppSocialMediaInfoSection.vue?vue&type=script&lang=js"
import style0 from "./AppSocialMediaInfoSection.vue?vue&type=style&index=0&id=4a7b69be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7b69be",
  null
  
)

export default component.exports